import styled from 'styled-components';

export const Bar = styled.div<{ width: number }>`
  position: relative;
  width: ${(props) => props.width}%;
  height: 32px;
  background-color: ${(props) => props.theme.colors['neutral-20']};
  border: 1px solid ${(props) => props.theme.colors['neutral-30']};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
`;

export const Label = styled.div<{ hasOpacity?: boolean }>`
  color: ${(props) =>
    !props.hasOpacity ? props.theme.colors['primary-70'] : props.theme.colors['secondary-60']};
  text-transform: capitalize;
  font-weight: 600;
  font-size: 14px;
`;

export const Container = styled.div`
  margin-bottom: 12px;
  width: 100%;
`;

export const Value = styled.div`
  color: ${(props) => props.theme.colors['primary-90']};
  margin-left: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;
